export default __webpack_public_path__ + "static/media/josh.4898bb41.jpg";